// ServicesDesignData.js
export const ServDesignTopImg = [
  {
    id: 0,
    image: require('../images/ServiceImg/ServDesign-00.jpg'),
    alt: 'ServiceImg/ServDesign-00.png',
    link: '',
  },
  {
    id: 1,
    image: require('../images/ServiceImg/ServDesign-01.jpg'),
    alt: 'ServiceImg/ServDesign-01.png',
    link: '',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/ServDesign-02.jpg'),
    alt: 'ServiceImg/ServDesign-02.png',
    link: '',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/ServDesign-03.jpg'),
    alt: 'ServiceImg/ServDesign-03.png',
    link: '',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/ServDesign-04.jpg'),
    alt: 'ServiceImg/ServDesign-04.png',
    link: '',
    // link: 'https://xxxxxx.com/design/xxxxxx',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/ServDesign-05.jpg'),
    alt: 'ServiceImg/ServDesign-05.png',
    link: '',
    // link: 'https://xxxxxx.com/design/xxxxxx',
  },
]

export const ServDesignTop = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDesignTouch.png'),
    // alt: 'ServiceImg/ServDesignTouch.png',
    name: 'Design PCAP Capacitive Touch Panel',
    title: '設計 PCAP 電容式觸控面板',
    subtitle: '',
    text:
      '設計先進的觸控產品，以在惡劣的專業環境中實現最佳性能，同時滿足或超越法規遵循和品質保證。\n' +
      'HLZ Elec Tech. 在中國和亞州的專業工程、設計和製造團隊擁有精良的裝備，能夠實現公司多品種、小批量生產和快速成型的能力。\n' +
      '此外，我們的設施擁有 10,000 級無塵室，確保產品符合高可靠性應用所需的嚴格品質要求。\n' +
      '我們致力於打造業界可靠的產品，符合嚴格的 ISO9001 和 ISOxxxxxx 標準\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
    '\n' +
    '\n',
    describe: 'ServDesignTop',
    // link: '',
    time: '2025/2/16',
  },
]

export const ServDesignTheory = [
  {
    id: 0,
    image: require('../images/ServiceImg/GGPCapTouchStruture.png'),
    alt: 'ServiceImg/GGPCapTouchStruture.png',
    name: 'How Does PCAP Touch Work?',
    title: 'P-Cap 觸控面板',
    subtitle: '結構圖：',
    text:
      // '結構圖：\n' +
      '   投射電容式觸控螢幕由多層組成。關鍵組件包括：\n' +
      '   • 蓋板：絕緣玻璃蓋板或塑膠蓋板，您觸摸的螢幕表面。\n' +
      '   • 光學膠：\n' +
      '   • 功能片：電極層(X,Y grid)，於蓋板下方\n' +
      '      ＊ 上層電極層\n' +
      '      ＊ 玻璃基板\n' +
      '      ＊ 下層電極層\n' +
      '      ＊ 軟性線路板\n' +
      '   • 控制IC：監控和處理觸控事件的系統。\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: 'How Does PCAP Touch Work?',
    subtitleEng: 'The Structure:',
    textEng:
      '1. The Structure:\n' +
      'A projected capacitive touchscreen is made of multiple layers. The key components are:\n' +
      '  • Insulating Glass or Plastic Cover: The surface of the screen that you touch.\n' +
      '  • Electrode Layer (X and Y Grids): Underneath the surface, there are two layers of conductive material arranged in a grid. One grid consists of rows, and the other of columns, forming a matrix of intersecting electrodes.\n' +
      '  • Controller: The system that monitors and processes touch events.\n' +
      'The conductive material (usually made from a transparent material like Indium Tin Oxide, or ITO) forms a capacitor at each intersection of the grid, creating a matrix of capacitive sensors.\n' +
      '\n',
    describe: 'ServDesignTheory',
    // link: '',
    time: '2025/2/13',
  },
  {
    id: 1,
    // image: require('../images/ServiceImg/GGPCapTouchStruture.png'),
    // alt: 'ServiceImg/GGPCapTouchStruture.png',
    name: 'How Does PCAP Touch Work?',
    title: 'PCAP 觸控面板如何運作？',
    subtitle: '結構：',
    text:
    '1．結構：\n' +
    '   投射電容式觸控螢幕由多層組成。關鍵組件包括：\n' +
    '   • 蓋板：絕緣玻璃蓋板或塑膠蓋板，您觸摸的螢幕表面。\n' +
    '   • 功能片：電極層(X,Y grid)，於蓋板下方，附於載體的兩層排列成網格的導電材。分別由行與列(X/Y)組成，形成相交電極矩陣。\n' +
    '   • 控制IC：監控和處理觸控事件的系統。\n' +
    '   導電材料(通常由氧化銦錫或 ITO 等透明材料製成)在網格的每個交叉點形成一個電容器，從而創建電容式感測器矩陣。\n' +
    '\n' +
      '2．電容式感應：\n' +
      '   電極會不斷產生微小的靜電場。當手指（或任何導電物體）靠近或觸摸表面時，會引起局部靜電場的變化，因為人體可以導電並改變電容。\n' +
      '   • 電容是電氣系統在電場中儲存能量的特性。螢幕透過檢測電容的變化來運作。\n' +
      '   每次觸摸都會引起接觸點處電容的可測量變化。控制器會偵測到這種變化，並透過比較來自電網的訊號來精確定位觸控的位置。\n' +
      '\n' +
      '3．投射電容方式：\n' +
      '   在 P-Cap 系統中，來自電極的電場「投射」到表面之外，即使沒有直接接觸（例如透過手套或薄表面）也可以檢測到觸摸。\n' +
      '   叉點都充當獨立的感測器，因此系統可以偵測多個觸控點。\n' +
      '\n' +
      '4．多點觸控：\n' +
      '   P-Cap 能夠進行多點觸控偵測，因為它可以同時追蹤多個點的電容變化。\n' +
      '   這是透過感應整個電極網格的變化並根據訊號強度和模式區分不同的觸摸來實現的。\n' +
      '\n' +
      '5．投射電容式觸控的優點：\n' +
      '   • 高耐用性：即使表面有刮痕或髒污仍能運作\n' +
      '   • 多點觸控支援：允許捏合縮放、旋轉等手勢\n' +
      '   • 反應速度快：提供快速、精確的觸控反應\n' +
      '   • 無需校準：在各種環境下都能保持長期穩定\n' +
      '\n' +
      '6．觸控電容模型\n' +
      '   與自電容測量不同，對於給定的相互感測器佈局，沒有簡單的方法來近似預期的觸控電容。\n' +
      '   平行板近似不適用，因為在這種情況下「板」是 X 和 Y 電極的片段，比觸控蓋小得多。\n' +
      '   使用者的觸摸接觸主要由電極對和指尖之間的邊緣場和點場決定\n' +
      '\n' +
      ' 在設計互電容感測器時，可以優化節點佈局以滿足應用要求，例如：\n' +
      '   • 最大靈敏度\n' +
      '   • 最佳噪音容忍度\n' +
      '   • 最佳防水效果\n' +
      '   • 最小預設感測器電容(某些擷取技術對感測器電容有限制)\n' +
      '   • 最低功耗\n' +
      '   • 最小觸控延遲\n' +
      '\n' +
      '   所有應用程式都需要在這些屬性之間進行權衡，因為實現一個屬性就意味著要損害其他屬性。\n' +
      '   舉例來說，使用高交錯電極可達到最強的靈敏度。\n' +
      '   然而，要實現最小感測器電容，需要 X 和 Y 之間有更大的間距。\n' +
      '   增加 X-Y 分離會減少預設的 X-Y 電容，但也會減少電極之間平行段的長度。\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: 'How Does PCAP Touch Work?',
    subtitleEng: 'The Structure:',
    textEng:
      '2.	Capacitive Sensing:\n' +
      'The electrodes are constantly generating a small electrostatic field.\n' +
      'When a finger (or any conductive object) comes close to or touches the surface, it causes a change in the local electrostatic field because the human body can conduct electricity and alter the capacitance.\n' +
      '  • Capacitance is a property of an electrical system that stores energy in an electric field. The screen works by detecting changes in capacitance.\n' +
      'Each touch causes a measurable change in capacitance at the point of contact. The controller detects this change, and by comparing signals from the grid, it pinpoints the exact location of the touch.\n' +
      '\n' +
      '3.	Projected Capacitance:\n' +
      'In P-Cap systems, the electric field from the electrodes is "projected" beyond the surface, allowing the touch to be detected even without direct contact, like through gloves or thin surfaces.\n' +
      'The system can detect multiple touch points because each intersection of the grid acts as an independent sensor.\n' +
      '\n' +
      '4.	Multi-Touch:' +
      'P-Cap is capable of multi-touch detection because it can track changes in capacitance at multiple points simultaneously.\n' +
      'This is done by sensing changes across the entire electrode grid and distinguishing between different touches based on the signal strength and pattern.\n' +
      '\n' +
      '5.	Advantages of Projected Capacitive Touch:\n' +
      '  • High durability: Works even if the surface is scratched or dirty.\n' +
      '  • Multi-touch support: Allows gestures like pinch-to-zoom, rotation, etc.\n' +
      '  • Highly responsive: Provides a fast and accurate touch response.\n' +
      '  • No calibration required: Stable over time and across various environments\n' +
      '' +
      '' +
      '',
    describe: 'ServDesignTheory',
    // link: '',
    time: '2025/2/13',
  },
]

export const ServDesignSensor = [
  {
    id: 1,
    // image: require(''),
    alt: 'ServiceImg/ServDesignSensor.png',
    name: 'Sensor Glass/Film Design',
    title: 'Glass Sensor / Film Sensor 設計',
    subtitle: 'Glass Sensor / Film Sensor 設計',
    text:
      '1．功能片設計\n' +
      '   PCAP功能片原理分自容與互容感應方式，自容使用單層感應，互容。\n' +
      '   • ITO Pattern：DITO包含上下層(X/Y)雙層，SITO只有單層，圖形可為Diamond、Bar ring..，感應層寬按照手指點擊寬度最大不超過8\n' +
      '   • 通道數：\n' +
      '   • 導通線路：銀導通線路、金屬導通線路\n' +
      '   • 絕緣層線路保護：導線線路容易刮傷，考慮膜厚影響蓋板貼合\n' +
      '   • ITO接點：\n' +
      '   • FPC接點：\n' +
      '   • 消影：\n' +
      '   • Ground & Shielding：\n' +
      '   • 尺寸：OD、AA、VA\n' +
      '   • 厚度：\n' +
      '\n' +
      '2．Sensor Glass特點：\n' +
      '   • 化學強化\n' +
      '   • 堅固耐用\n' +
      '\n' +
      '2．Film Glass特點：\n' +
      '   • 輕薄\n' +
      '\n' +
      '',
    nameEng: 'Aerospace Touch Screen Display Solutions',
    titleEng: 'Aerospace Touch Screen Display Solutions',
    subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
    textEng:
      '1. Sensor Design\n' +
      'If your industrial LCD display faces rough environmental conditions, your LCD design must prioritize coverglass protection and ruggedization.\n' +
      '\n' +
      '2. Sensor Glass Features:\n' +
      '     • Chemically-Strengthened\n' +
      '     • Ruggedized\n' +
      '\n' +
      '',
    describe: 'ServDesignSensor',
    link: '',
    time: '2025/2/18',
  },
]

export const ServDesignCover = [
  {
    id: 1,
    // image: require(''),
    // image: require('../images/ServiceImg/ServDesign'),
    alt: '',
    // alt: 'ServiceImg/ServDesignIndustrial.png',
    name: 'Cover Glass Introduction',
    title: '什麼是觸控螢幕保護玻璃？',
    text:
      '1．玻璃保護蓋板介紹：\n' +
      '   也稱為保護玻璃或保護玻璃，廣泛應用於智慧型手機和平板電腦等具有觸控功能的電子設備。\n' +
      '   應用於前屏、後蓋，提供防摔、防刮、抗壓、耐高溫、液晶保護、美觀等必備功能.\n' +
      '   觸控螢幕保護玻璃是您在手機和平板電腦等裝置上與之互動的頂層。它與檢測您的觸摸的層不同。\n' +
      '   這種玻璃在保護設備免受損壞並確保清晰的可視性和靈敏的觸摸方面發揮著至關重要的作用。\n' +
      '   先進的玻璃生產技術：\n' +
      '   • 蓋板玻璃產業隨著先進的生產技術而不斷發展。主要有兩種方法：溢流法、浮動法。\n' +
      '   • 在溢流法中，生產過程中原玻璃片表面不接觸其他介面，使最終產品無需研磨或拋光即可保持高強度，從而提高產品良率。\n' +
      '   • 浮法技術較成熟，產能較高，成本較低。它可以生產大尺寸玻璃，並以其成本優勢而聞名，儘管與溢流法相比，它的生產穩定性較低。\n' +
      '\n' +
      '2．蓋玻蓋板類型：\n' +
      '   • 康寧大猩猩玻璃(Gorilla\n' +
      '   • 旭龍跡玻璃(Dragontrail) \n' +
      '   • 藍寶石水晶玻璃\n' +
      '   • 肖特鋁矽酸鹽玻璃\n' +
      '   • 鈉鈣玻璃\n' +
      '   • 硼矽酸鹽玻璃\n' +
      '\n' +
      '3．高品質蓋板玻璃的優勢\n' +
      '   • 耐刮擦性高：硬度達到6~9H，避免粗糙物體劃傷\n' +
      '   • 耐用性：玻璃隨著時間的推移而承受磨損的能力\n' +
      '   • 明晰：高品質蓋板玻璃晶瑩剔透，螢幕上看起來都很清晰，意味著鮮豔的色彩和清晰的影像\n' +
      '   • 表面處理：防眩光(AG)、抗反射(AR)、防指紋(AF)、抗菌\n' +
      '   • 防爆玻璃：防爆玻璃設計可承受高衝擊而不破碎\n' +
      '   • 厚度選擇：玻璃的厚度影響其強度和重量，較厚的玻璃通常可以提供更好的保護，\n' +
      '   • 形狀訂製：弧形玻璃(曲面)、圓角邊緣、直角和不規則形狀\n' +
      '   • 鑽孔：通孔、盲孔\n' +
      '   • 表面絲網印刷： 此過程將設計或顏色直接應用到玻璃表面上\n' +
      '\n' +
      '3．蓋玻蓋板規格：\n' +
      '   • 厚度設計：搭配整體機構考量\n' +
      '   • 材質：鈉鈣、\n' +
      '   • 圖形與顏色：邊緣遮蓋必須蓋住Sensor銀線，且大於LCM AA 單邊0.2mm\n' +
      '   • 圖形與字符：\n' +
      '   • 膜層厚度：印刷必須2~3次，以避免針孔，印刷總厚度小於15um\n' +
      '   • 鍍膜： AR、AF、AS\n' +
      '   • 防爆模：\n' +
      '   • 翹曲度：\n' +
      '   • 強化：化學強化、物理強化，防刮達到6~9H\n' +
      '\n' +
      '4．複合板蓋板\n' +
      '   • 尺寸設計：OD、AA、VA 設計\n' +
      '   • 1.0、2.0mm\n' +
      '   • 材質：PMMA+PC 2層、PMMA+PC+PMMA 3層\n' +
      '\n',
    titleEng: 'Decolation Cover Design',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDesignCover',
    link: 'https://www.eagle-touch.com/zh-TW/all-you-need-to-know-about-touch-screen-cover-glass/',
    time: '2025/2/18',
  },
  {
    id: 2,
    // image: require(''),
    // image: require('../images/ServiceImg/ServDesign'),
    alt: '',
    // alt: 'ServiceImg/ServDesignIndustrial.png',
    name: 'Cover Design',
    title: '蓋板(Glass Cover / Plastic Cover)設計',
    text:
      '如果您的顯示器(LCM)面臨惡劣的環境條件，您的模組設計必須優先考慮蓋板玻璃的保護和加固。\n' +
      '1．玻璃保護蓋板：\n' +
      '   • 尺寸設計：OD、AA、VA 設計\n' +
      '   • 厚度設計：搭配整體機構考量\n' +
      '   • 材質：鈉鈣、\n' +
      '   • 圖形與顏色：邊緣遮蓋必須蓋住Sensor銀線，且大於LCM AA 單邊0.2mm\n' +
      '   • 圖形與字符：\n' +
      '   • 膜層厚度：印刷必須2~3次，以避免針孔，印刷總厚度小於15um\n' +
      '   • 鍍膜： AR、AF、AS\n' +
      '   • 防爆模：\n' +
      '   • 翹曲度：\n' +
      '   • 強化：化學強化、物理強化，防刮達到6~9H\n' +
      '\n' +
      '2．複合板蓋板\n' +
      '   • 尺寸設計：OD、AA、VA設計\n' +
      '   • 厚度設計：取決於複合板材厚度，一般為1.0、2.0mm\n' +
      '   • 材質：PMMA+PC 2層、PMMA+PC+PMMA 3層\n' +
      '\n' +
      '\n',
    titleEng: 'Decolation Cover Design',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDesignCover',
    link: '',
    time: '2025/2/18',
  },
]

export const ServDesignFpc = [
  {
    id: 1,
    // image: require(''),
    // image: require('../images/ServiceImg/ServDesign'),
    alt: '',
    // alt: 'ServiceImg/ServDesignIndustrial.png',
    name: 'FPC/FPCA/PCBA Design',
    title: 'FPC/FPCA/PCBA設計',
    text:
      '1．FPC設計\n' +
      '   • 外型設計：OD\n' +
      '   • 厚度要求：\n' +
      '   • 材質：\n' +
      '   • 佈線(Routing)：\n' +
      '      ＊ 按照Design Guide佈線建議\n' +
      '      ＊ 依照電源穩定性規定\n' +
      '      ＊ 建議加大銅面積以提高靈敏度\n' +
      '      ＊ 使用hush-ground接地來找到一個最佳點，既能提高免疫力，又能避免引入過多的寄生電容，從而降低靈敏度、\n' +
      '      ＊ 使用主動驅動防護罩\n' +
      '      ＊ 允許覆蓋材料的厚度和類型限制\n' +
      '   • FPC熱壓：ACF選擇\n' +
      '   • 連接頭：\n' +
      '   • 功能測試：\n' +
      '\n' +
      '2．FPCA設計\n' +
      '   • 外型設計：OD\n' +
      '   • 厚度要求：\n' +
      '   • 材質：\n' +
      '   • 走線layout：雙面軟板走線\n' +
      '   • FPC Bonding：ACF選擇\n' +
      '   • Connector：\n' +
      '   • Control IC：\n' +
      '   • Firmware 調適：\n' +
      '   • 功能測試：短路測試\n' +
      '\n' +
      '' +
      '3．Control Board(PCBA)設計\n' +
      '   • Outsourcing：\n' +
      '   • Control IC：\n' +
      '   • Firmware 調適：\n' +
      '   • 功能測試：\n' +
      '\n' +
      '' +
      '4．Control Board(PCBA)設計' +
      '' +
      '',
    titleEng: '',
    textEng:
      '\n' +
      '\n' +
      '\n' +
      '\n' +
      '\n',
    describe: 'ServDesignFpc',
    link: '',
    time: '2025/2/16',
  },
]

export const ServDesignIntegrate = [
  {
    id: 1,
    // image: require(''),
    // image: require('../images/ServiceImg/ServDesign'),
    alt: '',
    // alt: 'ServiceImg/ServDesignIndustrial.png',
    name: 'Integration/Lamination',
    title: 'Cover+(Sensor+Fpc) 貼合',
    text:
    '1．Sensor OCA Attach\n' +
    '   • \n' +
    '   • \n' +
    '\n' +
    '2．FPC/FPCA Bonding\n' +
    '   • \n' +
    '   • \n' +
    '\n' +
    '3．Laminatie\n' +
    '   • \n' +
    '   • \n' +
    '\n' +
    '4．Tunning & Testing\n' +
    '   • \n' +
    '   • \n' +
    '\n',
    titleEng: '',
    textEng:
      '　' +
      '　' +
      '　' +
      '　' +
      '　' +
      '',
    describe: 'ServDesignIntegrate',
    link: '',
    time: '2025/2/16',
  },
]

  // {
  //   id: 5,
  //   image: require('../images/ServiceImg/ServDesign'),
  //   alt: 'ServiceImg/ServDesignIndustrial.png',
  //   name: 'Integration/Lamination',
  //   title: '觸控電容模型',
  //   text:
  //     '與自電容測量不同，對於給定的相互感測器佈局，沒有簡單的方法來近似預期的觸控電容。\n' +
  //     '平行板近似不適用，因為在這種情況下「板」是 X 和 Y 電極的片段，比觸控蓋小得多。\n' +
  //     '使用者的觸摸接觸主要由電極對和指尖之間的邊緣場和點場決定\n' +
  //     '\n' +
  //     '在設計互電容感測器時，可以優化節點佈局以滿足應用要求，例如：\n' +
  //     '\n' +
  //     '   • 最大靈敏度\n' +
  //     '   • 最佳噪音容忍度\n' +
  //     '   • 最佳防水效果\n' +
  //     '   • 最小預設感測器電容(某些擷取技術對感測器電容有限制)\n' +
  //     '   • 最低功耗\n' +
  //     '   • 最小觸控延遲\n' +
  //     '\n' +
  //     '所有應用程式都需要在這些屬性之間進行權衡，因為實現一個屬性就意味著要損害其他屬性。\n' +
  //     '舉例來說，使用高交錯電極可達到最強的靈敏度。\n' +
  //     '然而，要實現最小感測器電容，需要 X 和 Y 之間有更大的間距。\n' +
  //     '增加 X-Y 分離會減少預設的 X-Y 電容，但也會減少電極之間平行段的長度。\n' +
  //     '\n' +
  //     '\n',
  //   titleEng: 'Touch Capacitance Model',
  //   textEng:
  //     "Unlike for self-capacitance measurements, there is no simple way to approximate the expected touch capacitance for a given mutual sensor layout.\n" +
  //     "The parallel plate approximation is not applicable as the ‘plates’ in this case are segments of the X and Y electrodes, which are much smaller than the touch cover.\n" +
  //     "The user’s touch contact is dominated by edge and point fields between the electrode pair and the fingertip." +
  //     '\n' +
  //     'When designing mutual capacitance sensors, the node layout may be optimized to suit application requirements such as:\n' +
  //     '   • Maximum sensitivity\n' +
  //     '   • Best noise tolerance\n' +
  //     '   • Best water rejection\n' +
  //     '   • Minimum default sensor capacitance (some acquisition technologies have a limit on the sensor capacitance)\n' + 
  //     '   • Minimum power consumption\n' +
  //     '   • Minimum touch latency\n' +
  //     '\n' +
  //     'All applications will require a trade-off between these properties, as achieving one will mean compromising others.\n' +
  //     'As an example, the strongest sensitivity is achieved using high interleaving of electrodes.\n' +
  //     '\n' +
  //     'However, achieving minimum sensor capacitance requires a larger spacing between X and Y.\n' +
  //     'Excess sensor capacitance increases acquisition time and power consumption.\n' +
  //     'Increasing X-Y separation reduces default X-Y capacitance, but it also reduces the lengths of parallel segments between the electrodes.\n' +
  //     '\n' +
  //     '\n' +
  //     '',
  //   describe: '',
  //   link: '',
  //   time: '2025/2/16',
  // },

